import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section-card" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = { class: "section-title" }
const _hoisted_4 = { class: "attachments-list" }
const _hoisted_5 = { class: "attachment-thumb" }
const _hoisted_6 = { class: "attachment-copy" }
const _hoisted_7 = { class: "attachment-text" }

type AttachmentItem = {
  url: string;
  description: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'InquiryDetailAttachmentsSection',
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, "Attachments (" + _toDisplayString(__props.items.length) + ")", 1)
    ]),
    _createVNode(_component_v_divider),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.url || item.description,
          class: "attachment-row"
        }, [
          _createElementVNode("div", _hoisted_5, [
            (item.url)
              ? (_openBlock(), _createBlock(_component_v_img, {
                  key: 0,
                  src: item.url,
                  alt: item.description || 'Attachment',
                  class: "attachment-image",
                  contain: ""
                }, null, 8, ["src", "alt"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(item.description), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})